import { context } from '@utils/tool/khook';

import type { WidgetProps, InsideState } from './types'
import type { ReviewsQuery } from './action'
import type { RefWidget } from './hooks/useWidget'

/**
 * write 事件
 * table 筛选事件 点击事件
 * 分页变化事件
 * 好评事件,差评事件
 * 分享事件
 * reply事件
 *
 */

type Ref = {
  current: RefWidget
  reviewsQuery: ReviewsQuery
  main: { ViewPhotosDetail; InfiniteScroll? }
}

type WriteReviewsState = {
  isExpand: boolean
  open: boolean
  userRating: number
  tabsKey: string
  selectValue: number
}

export type ReviewPhotosArea = {
  reviewCard: WidgetProps['reviews']
  reviewPhotos: WidgetProps['reviews'][number]['medium']
}

export const ctx = context<
  ReviewPhotosArea & WidgetProps & WriteReviewsState & InsideState,
  Ref
>({
  open: false,
  userRating: 5,
  selectValue: 0,
  tabsKey: '1',
  isExpand: false
})
